export type Language = 'pl' | 'ru'

export const translations = {
  pl: {
    appName: 'SG Flow',
    appSubtitle: 'Sisters Garden',
    loginTitle: 'Zaloguj się',
    email: 'Email',
    password: 'Hasło',
    signIn: 'Zaloguj',
    signingIn: 'Logowanie...',
    forgotPassword: 'Nie pamiętasz hasła?',
    resetSent: 'Link do zmiany hasła został wysłany.',
    logout: 'Wyloguj',
    language: 'Język',
    configurationNeeded: 'Wymagana konfiguracja',
    configurationText: 'Dodaj adres projektu Supabase i klucz publishable do zmiennych środowiskowych.',
    dashboard: 'Pulpit',
    leads: 'Zapytania',
    clients: 'Klienci',
    orders: 'Zamówienia',
    projects: 'Projekty',
    calendar: 'Kalendarz',
    purchases: 'Zakupy',
    finances: 'Finanse',
    tasks: 'Zadania',
    reports: 'Raporty',
    settings: 'Ustawienia',
    today: 'Dzisiaj',
    quickAdd: 'Dodaj',
    newLead: 'Nowe zapytanie',
    newClient: 'Nowy klient',
    newOrder: 'Nowe zamówienie',
    newExpense: 'Nowy koszt',
    newTask: 'Nowe zadanie',
    welcome: 'Dzień dobry',
    dashboardIntro: 'Najważniejsze informacje operacyjne Sisters Garden.',
    openLeads: 'Otwarte zapytania',
    leadsToday: 'Zapytania dzisiaj',
    waitingLeads: 'Oczekujące na klienta',
    conversion: 'Konwersja',
    wonThisMonth: 'Wygrane w tym miesiącu',
    lostThisMonth: 'Przegrane w tym miesiącu',
    recentLeads: 'Ostatnie zapytania',
    moduleReadyLater: 'Moduł jest przygotowany w architekturze i będzie rozwijany w kolejnych iteracjach.',
    role: 'Rola',
    owner: 'Właściciel',
    consultant: 'Konsultant',
    florist: 'Florysta',
    unknownUser: 'Użytkownik',
    save: 'Zapisz',
    saving: 'Zapisywanie...',
    cancel: 'Anuluj',
    edit: 'Edytuj',
    close: 'Zamknij',
    search: 'Szukaj',
    clearFilters: 'Wyczyść filtry',
    status: 'Status',
    responsible: 'Osoba odpowiedzialna',
    source: 'Źródło',
    service: 'Usługa',
    date: 'Data',
    amount: 'Kwota',
    actions: 'Akcje',
    noData: 'Brak danych',
    errorLoading: 'Nie udało się pobrać danych.',
    errorSaving: 'Nie udało się zapisać danych.',
    saved: 'Dane zostały zapisane.',
    active: 'Aktywny',
    archived: 'Archiwalny',
    all: 'Wszystkie',
    individual: 'Osoba prywatna',
    company: 'Firma',
    clientType: 'Typ klienta',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    companyName: 'Nazwa firmy',
    phone: 'Telefon',
    instagram: 'Instagram',
    preferredContact: 'Preferowany kontakt',
    notes: 'Notatki',
    marketingConsent: 'Zgody marketingowe',
    marketingEmail: 'Email marketingowy',
    marketingSms: 'SMS marketingowy',
    marketingPhone: 'Kontakt telefoniczny',
    client: 'Klient',
    clientName: 'Nazwa klienta',
    firstSource: 'Pierwsze źródło',
    totalOrders: 'Zamówienia',
    totalLeads: 'Zapytania',
    lifetimeValue: 'Łączna sprzedaż',
    lastOrder: 'Ostatnie zamówienie',
    createClient: 'Dodaj klienta',
    editClient: 'Edytuj klienta',
    clientsEmpty: 'Nie ma jeszcze klientów',
    clientsEmptyDescription: 'Dodaj pierwszego klienta lub utwórz go podczas rejestrowania zapytania.',
    clientCreated: 'Klient został dodany.',
    clientUpdated: 'Dane klienta zostały zaktualizowane.',
    showInactive: 'Pokaż archiwalnych',
    contactLabel: 'Nazwa lub nick klienta',
    existingClient: 'Istniejący klient',
    newContactOnly: 'Tylko nazwa kontaktu',
    createNewClient: 'Utwórz nowego klienta',
    desiredDate: 'Termin realizacji',
    budgetGross: 'Budżet brutto',
    occasion: 'Okazja',
    lostReason: 'Powód utraty',
    createdAt: 'Utworzono',
    createLead: 'Dodaj zapytanie',
    editLead: 'Edytuj zapytanie',
    leadsEmpty: 'Nie ma jeszcze zapytań',
    leadsEmptyDescription: 'Dodaj pierwsze zapytanie z Instagrama, telefonu, strony lub polecenia.',
    leadCreated: 'Zapytanie zostało dodane.',
    leadUpdated: 'Zapytanie zostało zaktualizowane.',
    chooseClientMode: 'Sposób identyfikacji klienta',
    chooseClient: 'Wybierz klienta',
    chooseSource: 'Wybierz źródło',
    chooseService: 'Wybierz usługę',
    chooseResponsible: 'Wybierz osobę odpowiedzialną',
    chooseStatus: 'Wybierz status',
    filters: 'Filtry',
    statusAll: 'Wszystkie statusy',
    responsibleAll: 'Wszyscy odpowiedzialni',
    sourceAll: 'Wszystkie źródła',
    convertToOrder: 'Utwórz zamówienie',
    conversionTitle: 'Konwersja zapytania w zamówienie',
    fulfilmentDateTime: 'Data i godzina realizacji',
    orderAmountGross: 'Wartość zamówienia brutto',
    deliveryMethod: 'Sposób realizacji',
    pickup: 'Odbiór osobisty',
    delivery: 'Dostawa',
    onsite: 'Realizacja na miejscu',
    deliveryAddress: 'Adres dostawy',
    createOrder: 'Utwórz zamówienie',
    orderCreated: 'Zamówienie zostało utworzone, a zapytanie oznaczono jako wygrane.',
    clientRequiredForOrder: 'Aby utworzyć zamówienie, zapytanie musi być powiązane z kartą klienta.',
    noResults: 'Brak wyników',
    noResultsDescription: 'Zmień wyszukiwanie lub filtry.',
    refresh: 'Odśwież',
    requiredFields: 'Pola oznaczone gwiazdką są obowiązkowe.',
    number: 'Numer',
    summary: 'Podsumowanie',
    decidedLeads: 'Rozstrzygnięte zapytania',
    openDetails: 'Otwórz szczegóły',
    noRecentLeads: 'Brak ostatnich zapytań.',
    archive: 'Archiwizuj',
    restore: 'Przywróć',
    deletePermanently: 'Usuń trwale',
    confirmDeleteClient: 'Czy na pewno trwale usunąć tego klienta? Tej operacji nie można cofnąć.',
    clientDeleted: 'Klient został trwale usunięty.',
    clientArchived: 'Klient został przeniesiony do archiwum.',
    clientRestored: 'Klient został przywrócony.',
    clientHasRelations: 'Nie można trwale usunąć klienta powiązanego z zapytaniami, zamówieniami lub projektami. Najpierw przenieś go do archiwum.',
    ordersEmpty: 'Nie ma jeszcze zamówień',
    ordersEmptyDescription: 'Zamówienia pojawią się tutaj po konwersji zapytania.',
    confirmationStatus: 'Potwierdzenie',
    paymentStatus: 'Płatność',
    fulfilmentStatus: 'Realizacja',
    draft: 'Szkic',
    confirmed: 'Potwierdzone',
    cancelled: 'Anulowane',
    unpaid: 'Nieopłacone',
    partiallyPaid: 'Częściowo opłacone',
    paid: 'Opłacone',
    overdue: 'Przeterminowane',
    refunded: 'Zwrócone',
    toPlan: 'Do zaplanowania',
    toPurchase: 'Do zakupu',
    inProduction: 'W realizacji',
    ready: 'Gotowe',
    waitingForPickup: 'Oczekuje na odbiór',
    inDelivery: 'W dostawie',
    delivered: 'Dostarczone',
    completed: 'Zakończone',
    complaint: 'Reklamacja',
    orderTitle: 'Nazwa zamówienia',
    vatRate: 'Stawka VAT',
    orderCreatedStandalone: 'Zamówienie zostało utworzone.',
    createExpense: 'Dodaj koszt',
    expenseCreated: 'Koszt został dodany.',
    expensesEmpty: 'Nie ma jeszcze kosztów',
    expensesEmptyDescription: 'Dodaj pierwszy koszt i opcjonalnie przypisz go do zamówienia.',
    expenseCategory: 'Kategoria kosztu',
    expenseDate: 'Data kosztu',
    supplier: 'Dostawca',
    relatedOrder: 'Powiązane zamówienie',
    amountNet: 'Kwota netto',
    amountGross: 'Kwota brutto',
    deleteLead: 'Usuń zapytanie',
    confirmDeleteLead: 'Czy na pewno usunąć to zapytanie? Tej operacji nie można cofnąć.',
    leadDeleted: 'Zapytanie zostało usunięte.',
    deleteOrder: 'Usuń zamówienie',
    confirmDeleteOrder: 'Czy na pewno usunąć to zamówienie? Tej operacji nie można cofnąć.',
    orderDeleted: 'Zamówienie zostało usunięte.',
    recipientName: 'Imię odbiorcy',
    recipientPhone: 'Telefon odbiorcy',
    recipientRequired: 'Przy dostawie podaj imię, telefon i adres odbiorcy.',
    quickClientRequired: 'Dla nowego klienta podaj nazwę lub imię oraz numer telefonu.'
  },
  ru: {
    appName: 'SG Flow',
    appSubtitle: 'Sisters Garden',
    loginTitle: 'Вход в систему',
    email: 'Email',
    password: 'Пароль',
    signIn: 'Войти',
    signingIn: 'Вход...',
    forgotPassword: 'Забыли пароль?',
    resetSent: 'Ссылка для смены пароля отправлена.',
    logout: 'Выйти',
    language: 'Язык',
    configurationNeeded: 'Требуется настройка',
    configurationText: 'Добавьте адрес проекта Supabase и publishable key в переменные окружения.',
    dashboard: 'Главная',
    leads: 'Запросы',
    clients: 'Клиенты',
    orders: 'Заказы',
    projects: 'Проекты',
    calendar: 'Календарь',
    purchases: 'Закупки',
    finances: 'Финансы',
    tasks: 'Задачи',
    reports: 'Отчёты',
    settings: 'Настройки',
    today: 'Сегодня',
    quickAdd: 'Добавить',
    newLead: 'Новый запрос',
    newClient: 'Новый клиент',
    newOrder: 'Новый заказ',
    newExpense: 'Новый расход',
    newTask: 'Новая задача',
    welcome: 'Добрый день',
    dashboardIntro: 'Главная оперативная информация Sisters Garden.',
    openLeads: 'Открытые запросы',
    leadsToday: 'Запросы сегодня',
    waitingLeads: 'Ожидают клиента',
    conversion: 'Конверсия',
    wonThisMonth: 'Подтверждено в этом месяце',
    lostThisMonth: 'Отказы в этом месяце',
    recentLeads: 'Последние запросы',
    moduleReadyLater: 'Модуль заложен в архитектуру и будет развиваться в следующих итерациях.',
    role: 'Роль',
    owner: 'Владелец',
    consultant: 'Консультант',
    florist: 'Флорист',
    unknownUser: 'Пользователь',
    save: 'Сохранить',
    saving: 'Сохранение...',
    cancel: 'Отмена',
    edit: 'Редактировать',
    close: 'Закрыть',
    search: 'Поиск',
    clearFilters: 'Сбросить фильтры',
    status: 'Статус',
    responsible: 'Ответственный',
    source: 'Источник',
    service: 'Услуга',
    date: 'Дата',
    amount: 'Сумма',
    actions: 'Действия',
    noData: 'Нет данных',
    errorLoading: 'Не удалось загрузить данные.',
    errorSaving: 'Не удалось сохранить данные.',
    saved: 'Данные сохранены.',
    active: 'Активный',
    archived: 'Архивный',
    all: 'Все',
    individual: 'Частное лицо',
    company: 'Компания',
    clientType: 'Тип клиента',
    firstName: 'Имя',
    lastName: 'Фамилия',
    companyName: 'Название компании',
    phone: 'Телефон',
    instagram: 'Instagram',
    preferredContact: 'Предпочтительный способ связи',
    notes: 'Заметки',
    marketingConsent: 'Маркетинговые согласия',
    marketingEmail: 'Email-маркетинг',
    marketingSms: 'SMS-маркетинг',
    marketingPhone: 'Телефонный контакт',
    client: 'Клиент',
    clientName: 'Имя клиента',
    firstSource: 'Первый источник',
    totalOrders: 'Заказы',
    totalLeads: 'Запросы',
    lifetimeValue: 'Общая сумма продаж',
    lastOrder: 'Последний заказ',
    createClient: 'Добавить клиента',
    editClient: 'Редактировать клиента',
    clientsEmpty: 'Клиентов пока нет',
    clientsEmptyDescription: 'Добавьте первого клиента или создайте его во время регистрации запроса.',
    clientCreated: 'Клиент добавлен.',
    clientUpdated: 'Данные клиента обновлены.',
    showInactive: 'Показывать архивных',
    contactLabel: 'Имя или ник клиента',
    existingClient: 'Существующий клиент',
    newContactOnly: 'Только имя контакта',
    createNewClient: 'Создать нового клиента',
    desiredDate: 'Желаемая дата реализации',
    budgetGross: 'Бюджет брутто',
    occasion: 'Повод',
    lostReason: 'Причина отказа',
    createdAt: 'Создано',
    createLead: 'Добавить запрос',
    editLead: 'Редактировать запрос',
    leadsEmpty: 'Запросов пока нет',
    leadsEmptyDescription: 'Добавьте первый запрос из Instagram, телефона, сайта или рекомендации.',
    leadCreated: 'Запрос добавлен.',
    leadUpdated: 'Запрос обновлён.',
    chooseClientMode: 'Как указать клиента',
    chooseClient: 'Выберите клиента',
    chooseSource: 'Выберите источник',
    chooseService: 'Выберите услугу',
    chooseResponsible: 'Выберите ответственного',
    chooseStatus: 'Выберите статус',
    filters: 'Фильтры',
    statusAll: 'Все статусы',
    responsibleAll: 'Все ответственные',
    sourceAll: 'Все источники',
    convertToOrder: 'Создать заказ',
    conversionTitle: 'Преобразование запроса в заказ',
    fulfilmentDateTime: 'Дата и время реализации',
    orderAmountGross: 'Стоимость заказа брутто',
    deliveryMethod: 'Способ выполнения',
    pickup: 'Самовывоз',
    delivery: 'Доставка',
    onsite: 'Реализация на месте',
    deliveryAddress: 'Адрес доставки',
    createOrder: 'Создать заказ',
    orderCreated: 'Заказ создан, запрос отмечен как подтверждённый.',
    clientRequiredForOrder: 'Для создания заказа запрос должен быть связан с карточкой клиента.',
    noResults: 'Ничего не найдено',
    noResultsDescription: 'Измените поиск или фильтры.',
    refresh: 'Обновить',
    requiredFields: 'Поля со звёздочкой обязательны.',
    number: 'Номер',
    summary: 'Сводка',
    decidedLeads: 'Завершённые запросы',
    openDetails: 'Открыть детали',
    noRecentLeads: 'Недавних запросов нет.',
    archive: 'Архивировать',
    restore: 'Восстановить',
    deletePermanently: 'Удалить навсегда',
    confirmDeleteClient: 'Удалить этого клиента навсегда? Это действие нельзя отменить.',
    clientDeleted: 'Клиент удалён навсегда.',
    clientArchived: 'Клиент перемещён в архив.',
    clientRestored: 'Клиент восстановлен.',
    clientHasRelations: 'Нельзя навсегда удалить клиента, связанного с запросами, заказами или проектами. Используйте архивирование.',
    ordersEmpty: 'Заказов пока нет',
    ordersEmptyDescription: 'Заказы появятся здесь после преобразования запроса.',
    confirmationStatus: 'Подтверждение',
    paymentStatus: 'Оплата',
    fulfilmentStatus: 'Выполнение',
    draft: 'Черновик',
    confirmed: 'Подтверждён',
    cancelled: 'Отменён',
    unpaid: 'Не оплачено',
    partiallyPaid: 'Оплачено частично',
    paid: 'Оплачено',
    overdue: 'Просрочено',
    refunded: 'Возвращено',
    toPlan: 'Нужно запланировать',
    toPurchase: 'Нужна закупка',
    inProduction: 'В производстве',
    ready: 'Готово',
    waitingForPickup: 'Ожидает самовывоза',
    inDelivery: 'В доставке',
    delivered: 'Доставлено',
    completed: 'Завершено',
    complaint: 'Рекламация',
    orderTitle: 'Название заказа',
    vatRate: 'Ставка VAT',
    orderCreatedStandalone: 'Заказ создан.',
    createExpense: 'Добавить расход',
    expenseCreated: 'Расход добавлен.',
    expensesEmpty: 'Расходов пока нет',
    expensesEmptyDescription: 'Добавьте первый расход и при необходимости свяжите его с заказом.',
    expenseCategory: 'Категория расхода',
    expenseDate: 'Дата расхода',
    supplier: 'Поставщик',
    relatedOrder: 'Связанный заказ',
    amountNet: 'Сумма нетто',
    amountGross: 'Сумма брутто',
    deleteLead: 'Удалить запрос',
    confirmDeleteLead: 'Удалить этот запрос навсегда? Это действие нельзя отменить.',
    leadDeleted: 'Запрос удалён.',
    deleteOrder: 'Удалить заказ',
    confirmDeleteOrder: 'Удалить этот заказ навсегда? Это действие нельзя отменить.',
    orderDeleted: 'Заказ удалён.',
    recipientName: 'Имя получателя',
    recipientPhone: 'Телефон получателя',
    recipientRequired: 'Для доставки укажите имя, телефон и адрес получателя.',
    quickClientRequired: 'Для нового клиента укажите имя или название и номер телефона.'
  }
} as const

export type TranslationKey = keyof typeof translations.pl
